import { MedicalPath } from "types/entity"
import { GlobalStore } from "types/store"

import { getNextDoctor as nextDoctor } from "./saga"

export function getNextDoctor({ client }: GlobalStore) {
  const medicalPath: MedicalPath = client.medicalPath
  return nextDoctor(medicalPath)
}
